import React from "react";
import {
  DiReact,
  DiHtml5,
  DiCss3,
  DiJavascript1,
  DiNodejsSmall,
  DiGithubBadge,
  DiAws,
  DiBitbucket,
  DiVisualstudio,
} from "react-icons/di";
import { FaSalesforce } from "react-icons/fa";
import { FiCpu, FiDatabase, FiGitBranch } from "react-icons/fi";

const techItems = [
  { Icon: FaSalesforce, title: "Salesforce" },
  { Icon: FiCpu, title: "Agentforce" },
  { Icon: FiDatabase, title: "Data 360" },
  { Icon: FiGitBranch, title: "Agentic AI" },
  { Icon: DiAws, title: "AWS" },
  { Icon: DiJavascript1, title: "JavaScript" },
  { Icon: DiReact, title: "React" },
  { Icon: DiNodejsSmall, title: "Node.js" },
  { Icon: DiHtml5, title: "HTML5" },
  { Icon: DiCss3, title: "CSS3" },
  { Icon: DiGithubBadge, title: "GitHub" },
  { Icon: DiBitbucket, title: "Bitbucket" },
  { Icon: DiVisualstudio, title: "VS Code" },
];

export default function Tech() {
  return (
    <div style={{ marginBottom: "clamp(60px, 9vh, 100px)" }}>
      <p
        className="reveal"
        style={{
          fontFamily: "var(--mono)",
          fontSize: "0.74rem",
          textTransform: "uppercase",
          letterSpacing: "0.16em",
          color: "var(--cyan)",
          marginBottom: "28px",
        }}
      >
        ▮ ARSENAL // STACK
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
          gap: "12px",
        }}
      >
        {techItems.map((item) => (
          <div
            key={item.title}
            className="reveal tech-cell"
            data-stagger="50"
            style={{
              position: "relative",
              background: "var(--panel)",
              border: "1px solid var(--line)",
              padding: "24px 14px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
              transition: "border-color 0.3s ease, box-shadow 0.3s ease, background 0.3s ease, transform 0.3s ease",
              cursor: "default",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "var(--cyan)";
              e.currentTarget.style.boxShadow = "0 0 24px rgba(52,224,255,0.28)";
              e.currentTarget.style.background = "rgba(52,224,255,0.07)";
              e.currentTarget.style.transform = "translateY(-4px)";
              const icon = e.currentTarget.querySelector("svg");
              const label = e.currentTarget.querySelector("span.label");
              if (icon) icon.style.filter = "drop-shadow(0 0 10px var(--glow))";
              if (label) label.style.color = "var(--cyan)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "var(--line)";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.background = "var(--panel)";
              e.currentTarget.style.transform = "none";
              const icon = e.currentTarget.querySelector("svg");
              const label = e.currentTarget.querySelector("span.label");
              if (icon) icon.style.filter = "none";
              if (label) label.style.color = "var(--text-soft)";
            }}
          >
            <item.Icon
              size="2.6em"
              style={{ color: "var(--text)", transition: "filter 0.3s ease" }}
            />
            <span
              className="label"
              style={{
                fontFamily: "var(--mono)",
                fontSize: "0.7rem",
                letterSpacing: "0.04em",
                color: "var(--text-soft)",
                transition: "color 0.3s ease",
              }}
            >
              {item.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
